<template>
  <div>
    <div class="card-img-slider" v-if="indexFile == active">
      <audio v-if="isSoundFormat(file)" controls autoplay>
        <source :src="originalFile" type="audio/mpeg" />
        <source :src="originalFile" type="audio/mp3" />
        <source :src="originalFile" type="audio/webm" />
        <source :src="originalFile" type="audio/ogg" />
        <source :src="originalFile" type="audio/3gpp" />
      </audio>
      <img v-if="isImageFormat(file)" :src="originalFile" class="image-size" />
      <img v-if="isDocFormat(file)" :src="originalFile" class="image-size" />
      <video
        v-if="isVideoFormat(file)"
        class="w-100 h-100"
        controls
        autoplay
        :src="originalFile"
      ></video>
    </div>
    <span class="prev" @click="move(-1)">
      <i class="fa fa-chevron-left" aria-hidden="true"></i>
    </span>
    <span class="next" @click="move(1)">
      <i class="fa fa-chevron-right" aria-hidden="true"></i>
    </span>
  </div>
</template>
<script>
import { getAttachmentOriginal } from "@/services";
import { includes } from "ramda";
/**
 * @group contentPriview
 * این کامپوننت برای نمایش فایل  تعریف شده است
 */
export default {
  name: "content-priview", // نام کامپوننت
  props: {
    // ابجکت قایل
    file: {
      type: Object,
      default: () => {},
    },
    // جایگاه ابجکت فایل
    indexFile: {
      type: Number,
      default: 0,
    },
    // نمایش فایل کلیک شده
    active: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      originalFile: "",
    };
  },
  methods: {
    includes,
    /**
     * @vuese
     * 	برای جابه جایی اسلایدر
     *  @arg  یارامتر ارسالی 1 به نام amount
     */
    move(amount) {
      this.$emit("move", amount);
    },
    /**
     * @vuese
     * 	چک کردن نوع فایل
     *  @arg  یارامتر ارسالی ابجکت فایل به نام file
     */
    isVideoFormat(file) {
      if (includes(file.ext, ["mp4", "m4v"])) return true;
      return false;
    },
    isSoundFormat(file) {
      if (
        includes(file.ext, ["mp3", "wmv", "m4a", "wave", "webm", "ogg", "3gp"])
      )
        return true;
      return false;
    },
    isImageFormat(file) {
      if (file.type.match("image")) return true;
      return false;
    },
    isDocFormat(file) {
      if (file.type.match("application")) return true;
      return false;
    },
    async handleGetAttachmentOriginal(code) {
      if (code) {
        try {
          const { src } = await getAttachmentOriginal(code);
          this.originalFile = src;
        } catch (error) {
          this.$generateError(error);
        }
      } else {
        toastAlert("file code not fount!", "error");
      }
    },
  },
  watch: {
    file: {
      immediate: true,
      handler({ download_code }) {
        if (download_code) {
          this.handleGetAttachmentOriginal(download_code);
        }
      },
    },
  },
  created() {
    const clientHeight = this.$refs.image && this.$refs.image.clientHeight;
    const clientWidth = this.$refs.image && this.$refs.image.clientWidth;

    if (clientHeight > clientWidth || clientHeight == clientWidth) {
      this.classImage = "w-100";
    } else {
      this.classImage = "h-100";
    }
  },
};
</script>
<style lang="scss">
.prev,
.next {
  position: absolute;
  top: 36%;
  width: 100px;
  height: 100px;
  border: 2px solid white;
  color: white;
  border-radius: 50%;
  background-color: #0404041f;
  cursor: pointer;
  left: -50px;
  line-height: 100px;
  text-align: center;
  text-indent: -10px;
  transition: all 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.275);

  &:hover {
    background: black;
    color: #fff;
  }

  &:active {
    transform: translate(0, 3px) scale(1.2);
  }

  @media (max-width: 600px) {
    top: 15%;
    width: 80px;
    height: 80px;
    line-height: 80px;
  }
}

.next {
  right: -50px;
  text-indent: 10px;
}

.card-img-slider {
  min-height: 500px;
  // max-height: 650px;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 600px) {
    min-height: 150px;
    max-height: auto;
    height: auto;
  }
}

.image-size {
  height: auto;
  max-width: 100%;
}
</style>
